export const OPEN_SELECTOR = 'accionOpenSelectorContrato';
export const CLOSE_SELECTOR = 'accionCloseSelectorContrato';

export const accionCloseSelectorContrato = () => ({
    type: CLOSE_SELECTOR
});
export const accionOpenSelectorContrato = () => ({
    type: OPEN_SELECTOR
});